import styled from "styled-components";
import {Descriptions} from "antd";

export const OrderMergeContainer = styled(Descriptions)`
    margin-top: 40px;
`;
export const CollapseContainer = styled.div`
    margin-top: 16px;
`;

export const MapContainer = styled.div`
    margin-top: 50px;
`;
